// France
export const locale = {
	lang: 'fr',
	data: {
		
	}
};
